exports = module.exports = require("../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vue-grid-layout{position:relative;transition:height .2s ease}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader?minimize!./~/.10.3.0@vue-loader/lib/style-rewriter.js?id=data-v-3d4bb9a4!./~/.10.3.0@vue-loader/lib/selector.js?type=styles&index=0!./src/GridLayout.vue
// module id = 11
// module chunks = 0